import React from 'react';

export const IconSmallCodeLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M10.014 17.836l2-12 1.972.328-2 12-1.972-.328zM17.586 12l-3.293-3.293 1.414-1.414 4 4 .707.707-.707.707-4 4-1.414-1.414L17.586 12zm-7.879 3.293L6.414 12l3.293-3.293-1.414-1.414-4 4-.707.707.707.707 4 4 1.414-1.414z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
